import { FormatVerticalAlignCenterIcon } from './FormatVerticalAlignCenterIcon';

/**
 * author: Google
 * id 4C8985BA-B48F-4015-9389-35672ECDE544
 * name format-vertical-align-center
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-vertical-align-center.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatVerticalAlignCentreIcon = FormatVerticalAlignCenterIcon;
export default FormatVerticalAlignCentreIcon